import React, { Component, Fragment } from 'react';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';
import Input from '@ertelecom/ui-react/components/inputSimple';
import { spasiboSberbankActivate } from '~/src/api/profile/sberbank';
import { connect } from 'react-redux';
import { selectDomain } from '~/src/store/selectors/domain';
import PropTypes from 'prop-types';
import { logout } from '~/src/store/actions/auth';
import { isAxiosError } from '~/src/helpers/whoseError';
import { captureException } from '@sentry/node';
import DefaultPopup from '@ertelecom/ui-react/components/popups/defaultPopup';
import {
    Container,
    GreyText,
    Header,
} from '~/src/components/Promo/popups/offer';
import Link from 'next/link';
import styled from 'styled-components';

const Button = styled(StyledButton)`
  width: unset;
  @media (max-width: 400px) {
        width: 100%;
  }
`;

class PromoCodeThanksSberForm extends Component {

    static propTypes = {
        accessToken: PropTypes.string.isRequired,
        domain: PropTypes.string.isRequired,
        logout: PropTypes.func.isRequired,
        onSuccess: PropTypes.func,
        onError: PropTypes.func,
    };

    static defaultProps = {
        onSuccess: () => {},
        onError: () => {},
    };

    state = {
        promoCode: '',
        isSending: false,
    };

    handleInput = (e) => {
        if (!e.target.value) {
            this.setState({
                promoCode: '',
            });
        }
        this.setState({
            promoCode: e.target.value.trim(),
        });
    };

    /**
     * от 5 до 15 латиских символов и цифр
     * @return {boolean}
     */
    get isValidCoupon() {
        const { promoCode } = this.state;
        return (/^[a-zA-Z\d]{5,15}$/).test(promoCode);
    }

    /**
     * @return {boolean}
     */
    get isNotValidCoupon() {
        const { promoCode } = this.state;
        return promoCode.length > 15;
    }

    get isDisabledButton() {
        const { isSending } = this.state;
        return !this.isValidCoupon || isSending;
    }

    sendCoupon = () => {
        this.setState({
            isSending: true,
        }, async() => {
            try {
                const { promoCode } = this.state;
                const { accessToken, domain } = this.props;
                await spasiboSberbankActivate(domain, accessToken, promoCode);
                this.setState({
                    isSending: false,
                }, () => {
                    this.props.onSuccess();
                });
            } catch (e) {
                if (isAxiosError(e)) {
                    if (e.response.status === 401) {
                        this.props.logout();
                        return;
                    }
                    if (e.response.status === 400) {
                        this.props.onError(e.response.data);
                        return;
                    }
                }
                e.message = 'spasiboSberbankActivate: ' + e.message;
                captureException(e);
                this.props.onError(e);
            }
        });
    };

    render() {
        const { promoCode } = this.state;
        return <Fragment>
            <Input type={'text'}
                   value={promoCode}
                   onChange={this.handleInput}
                   onPaste={this.handleInput}
                   isValid={this.isValidCoupon}
                   isNotValid={this.isNotValidCoupon}
                   placeholder={'Введите промокод'}
            />
            <Button
                disabled={this.isDisabledButton}
                onClick={this.sendCoupon}
            >
                Активировать купон
            </Button>
        </Fragment>;
    }
}

function mapStateToProps(state) {
    return {
        domain: selectDomain(state),
        accessToken: state.auth.accessToken,
    };
}

function mapDispatchToProps() {
    return {
        logout,
    };
}

export const PromoCodeThanksSberFormConnected = connect(mapStateToProps,
    mapDispatchToProps)(PromoCodeThanksSberForm);
/**
 * @param onClose
 * @param isOpen
 * @param onSuccess
 * @param onError
 * @param title
 * @param description
 * @param closeDate
 * @param paySum
 * @param terms
 * @return {JSX.Element}
 * @constructor
 */
export default function PromoCodeThanksSber({ onClose, isOpen, onSuccess, onError, offer: { title, description, closeDate, paySum, terms } }) {
    return <DefaultPopup onClose={onClose} isOpen={isOpen}>
        <Container>
            <Header>{title}</Header>
            <GreyText dangerouslySetInnerHTML={{ __html: description }}/>
            <RenderDateText closeDate={closeDate}/>
            <RenderCondition paySum={paySum}/>
            <PromoCodeThanksSberFormConnected onSuccess={onSuccess}
                                              onError={onError}/>
            <RenderTerms terms={terms}/>
        </Container>
    </DefaultPopup>;
}

/**
 * @param closeDate
 * @return {JSX.Element|null}
 * @constructor
 */
function RenderDateText({ closeDate }) {
    if (!closeDate) {
        return null;
    }

    const date = (new Date(closeDate)).toLocaleDateString('ru');

    return <GreyText>Акция длится до {date}. По истечении срока услуги
        отключатся автоматически.</GreyText>;
}

/**
 * @param paySum
 * @return {JSX.Element|null}
 * @constructor
 */
function RenderCondition({ paySum }) {
    if (!paySum) {
        return null;
    }

    if (paySum > 0) {
        return <GreyText>Чтобы воспользоваться предложением, <Link
            href='/payments' passHref><a>пополните
            счет</a></Link> на {paySum} руб.</GreyText>;
    }

    return <GreyText>Услуга подключится мгновенно.</GreyText>;
}

/**
 * @param terms
 * @return {JSX.Element|null}
 * @constructor
 */
function RenderTerms({ terms }) {
    if (!terms) {
        return null;
    }
    return <GreyText dangerouslySetInnerHTML={{ __html: terms }}/>;
}
